export default "__VITE_ASSET__COWSCzfG__"